import { FetchError } from "common/fetch/errors";
import { parseNumber } from "common/utils/numbers";
import { StatusCode } from "common/fetch/types";
import { useNavigate, useSearchState } from "common/router/hooks";
import errorImages from "common/constants/errorImages";

import ErrorPage from "client/common/components/errors/ErrorPage";
import FetchErrorPage from "client/common/components/errors/FetchErrorPage";
import { Paths, urls } from "client/routes";

const OnboardingSubscriptionsErrorPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchState<Paths["onboarding"]["subscriptions"]["error"]>({
    status: undefined,
  });

  if (params.status) {
    return (
      <FetchErrorPage
        entityName="Autoships"
        isPlural={true}
        error={new FetchError(parseNumber(params.status, StatusCode.InternalServerError))}
        buttonText="Try Again"
        onButtonClick={() => navigate(urls.onboarding.subscriptions.start())}
      />
    );
  }
  return (
    <ErrorPage
      image={errorImages.EmptyAutoships}
      imageAlt="Dog with calendar"
      title="Oops!"
      description="Something went wrong while loading your Autoships."
      buttonText="Try Again"
      buttonLink={urls.onboarding.subscriptions.start.to()}
    />
  );
};

export default OnboardingSubscriptionsErrorPage;
